// NFC scanning is gated here only: the API does not check who may scan.
// Test phase: just these accounts. Once tested this becomes
// `|| user?.profile_group_id == 1`. The login response's user carries it, and
// so does GET users/profile; a session started before that field existed has
// to log in again to get it.
const NFC_TEST_USER_IDS = [1, 763];

export function canUseNfc() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        return NFC_TEST_USER_IDS.includes(Number(user?.id));
    } catch {
        return false;
    }
}
